import { useEffect } from 'react';

const PROTECTED_PHASES = [
  'playing', 'roundEnd', 'shop', 'preGameShop',
  'victory', 'victoryOverview', 'victoryStatistics', 'victoryAwards', 'victoryFinal',
  'disconnected',
];

export function useGameSessionGuard(phase) {
  const isProtected = PROTECTED_PHASES.includes(phase);

  useEffect(() => {
    if (!isProtected) return;

    // beforeunload - browser shows standard "Leave site?" warning
    const onBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, [isProtected]);
}
